module.exports = __webpack_public_path__ + "it.b46f8792.svg";